import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/App";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import { ExternalLink, Bot, Sparkles, Heart, Globe, BookOpen, Shield, Zap, Users, Lock, Crown, ArrowRight } from "lucide-react";
import { hasFullAccess } from "@/components/PremiumGate";

const AGENTS = [
  {
    id: "relapse-reset",
    name: "RElapse.REset.Mind-SPA",
    shortName: "Relapse Reset",
    description: "Soulful AI coach for relapse transformation in the ME.WELL Global.VILLAGE.",
    starters: ["Guide me through my first reflective session today", "Help me explore my cycles without shame", "How can I prepare to truly transform?"],
    url: "https://chatgpt.com/g/g-686ca8034560819183011bbf96314ed9-relapse-reset-mind-spa",
    icon: Heart,
    gradient: "from-rose-500/15 to-pink-500/10",
    accent: "text-rose-600",
    accentBg: "bg-rose-500",
    tag: "Recovery",
  },
  {
    id: "smahoody-live",
    name: "Daily ME.WELL Mind-SPA Ai.2",
    shortName: "Daily ME.WELL Mind-SPA",
    description: "LIVE+ Ai.2 ME.WELL Life Skills Coach for STRESS.out, BURNT.out & RAPid Adaptive.TT Support.",
    starters: ["I need LIVE Sof.B conflict Adaptive.TT Self Care Coaching", "Quick non-clinical Mind.Emotional Status Check-In", "How to know if my Triggers Responses are Adaptive?"],
    url: "https://chatgpt.com/g/g-68376fd678248191a8a4f82f9b41edf4-smaho-arts-smahoody-live-ai-2",
    icon: Zap,
    gradient: "from-amber-500/15 to-orange-500/10",
    accent: "text-amber-600",
    accentBg: "bg-amber-500",
    tag: "Life Skills",
  },
  {
    id: "rapsoulr-live",
    name: "Mr. RAPsoul.R-Ai.2 LIVE",
    shortName: "RAPsoul.R LIVE",
    description: "Twice-daily premium ME.WELL coaching for burnout, stress, and adaptive trauma life skills routines.",
    starters: ["Book a GUIDED LIVE RAPsr.online Session", "Start My Booked LIVE GUIDED Session", "Start RAPsr.Ai.2 GUIDED Session NOW"],
    url: "https://chatgpt.com/g/g-6836170ff96c8191b6a40b017745fadb-mr-rapsoul-r-ai-2-live",
    icon: Sparkles,
    gradient: "from-violet-500/15 to-purple-500/10",
    accent: "text-violet-600",
    accentBg: "bg-violet-500",
    tag: "Premium",
  },
  {
    id: "global-village",
    name: "SMAHoo Global Social.VILLAGE Forum",
    shortName: "Global VILLAGE",
    description: "Creative strategist for the ME.WELL Global.VILLAGE Cooperative.",
    starters: ["How can I participate in the Global.VILLAGE Forum?", "What are the Four Pillars of the WHO Mental Health Action Plan?", "How do I become a grassroots Change Agent?"],
    url: "https://chatgpt.com/g/g-6835b29e1f188191be496b26c5b06f9d-smahoo-global-social-village-forum",
    icon: Globe,
    gradient: "from-emerald-500/15 to-teal-500/10",
    accent: "text-emerald-600",
    accentBg: "bg-emerald-500",
    tag: "Community",
  },
  {
    id: "faith-centred",
    name: "RAPS-ME.WELL Faith-Centred Mind-SPA Sof.B exPE",
    shortName: "Faith-Centred SPA",
    description: "Faith-centered and Present NOW.ISness needs cognition aligned interface for mindful intentional mind mental-emotional interplay wellness.",
    starters: ["Did You SMAHoo Today?", "Do you have everyday Stress.Stressors.Triggers?", "How is your ME.WELL Sof.WELL.b?"],
    url: "https://chatgpt.com/g/g-682007e3d26c81919ca33de71dfb1910-raps-me-well-faith-centred-mind-spa-sof-b-expe",
    icon: BookOpen,
    gradient: "from-sky-500/15 to-blue-500/10",
    accent: "text-sky-600",
    accentBg: "bg-sky-500",
    tag: "Faith",
  },
  {
    id: "myrtle-core",
    name: "Myrtle-CORE Global MH.Sof.B SMAHo.OS A1.2",
    shortName: "Myrtle-CORE OS",
    description: "Ai.2-powered Core OS shielded by the ME.WELL Mind-SPA SuperAPP Gateway shell.",
    starters: ["Did You SMAHoo Today?", "Do you have everyday Stress.Stressors.Triggers?", "Are you ready for 2030?"],
    url: "https://chatgpt.com/g/g-680ddcdfd9708191a02f724eb8300cf3-myrtle-core-global-mh-sof-b-smaho-os-a1-2",
    icon: Shield,
    gradient: "from-slate-500/15 to-zinc-500/10",
    accent: "text-slate-600",
    accentBg: "bg-slate-600",
    tag: "Core OS",
  },
  {
    id: "rice-peas-soul",
    name: "Rice And Peas For The Soul REVISITED (TIBTBT)",
    shortName: "Rice & Peas Soul",
    description: "Faith-based cognition-aligned adaptive life Skills Tele-Edu Drama framework by M. Shirvington A. Hannays.",
    starters: ["Did You SMAHoo Today?", "Do you have everyday Stress.Stressors.Triggers?", "Are you ready for 2030?"],
    url: "https://chatgpt.com/g/g-6801d0dca53881918059ee3f9b879927-rice-and-peas-for-the-soul-revisited-tibtbt",
    icon: Users,
    gradient: "from-orange-500/15 to-red-500/10",
    accent: "text-orange-600",
    accentBg: "bg-orange-500",
    tag: "Tele-Edu",
  },
  {
    id: "smahoody-ai2",
    name: "Mr. RAPsoul.R SMAHoody-Ai.2",
    shortName: "SMAHoody Ai.2",
    description: "Mr. RAPsoul.R, The Laughing Drama Therapist — Soul Signature SMAHoodies by M. Shirvington A. Hannays.",
    starters: ["Did You SMAHoo Today?", "Do you have everyday Stress.Stressors.Triggers?", "How is your ME.WELL Sof.WELL.b?"],
    url: "https://chatgpt.com/g/g-67fdc66e40948191976df748d145e5ab-mr-rapsoul-r-smahoody-ai-2",
    icon: Bot,
    gradient: "from-teal-500/15 to-cyan-500/10",
    accent: "text-teal-600",
    accentBg: "bg-teal-500",
    tag: "Signature",
  },
];

export default function AIAgents() {
  const [hoveredId, setHoveredId] = useState(null);
  const { user } = useAuth();
  const isFull = hasFullAccess(user);
  const visibleAgents = isFull ? AGENTS : AGENTS.slice(0, 2);

  return (
    <DashboardLayout>
      <div className="p-6 md:p-8 lg:p-12 space-y-8 animate-fade-in" data-testid="ai-agents-page">
        {/* Header */}
        <div className="relative overflow-hidden spa-card bg-gradient-to-br from-white to-spa-sage/10" data-testid="ai-agents-header">
          <div className="relative z-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-spa-terracotta rounded-2xl flex items-center justify-center">
                <Bot className="w-6 h-6 text-white" strokeWidth={1.5} />
              </div>
              <div>
                <p className="overline-text">SMAHOO & RAPsoul.R</p>
                <h1 className="font-serif text-3xl sm:text-4xl font-light text-spa-moss">
                  Signature Ai.2 Agents
                </h1>
              </div>
            </div>
            <p className="text-spa-text-secondary max-w-2xl mt-2">
              8 Core ChatGPT-powered coaching agents by Mr. RAPsoul.R (M. Shirvington A. Hannays). 
              Each agent specializes in a unique dimension of the ME.WELL Mind-SPA ecosystem — 
              from relapse recovery to faith-centered wellness to adaptive life skills.
            </p>
          </div>
          <div className="absolute -right-10 -top-10 w-40 h-40 bg-spa-sage/10 rounded-full blur-2xl"></div>
        </div>

        {/* Agent Grid */}
        <div className="grid md:grid-cols-2 gap-6" data-testid="ai-agents-grid">
          {visibleAgents.map((agent) => {
            const Icon = agent.icon;
            const isHovered = hoveredId === agent.id;
            return (
              <div
                key={agent.id}
                className={`spa-card group relative overflow-hidden bg-gradient-to-br ${agent.gradient} border transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5`}
                onMouseEnter={() => setHoveredId(agent.id)}
                onMouseLeave={() => setHoveredId(null)}
                data-testid={`agent-card-${agent.id}`}
              >
                {/* Tag */}
                <div className="absolute top-4 right-4">
                  <span className={`px-2.5 py-1 rounded-full text-[10px] font-semibold uppercase tracking-wider ${agent.accentBg} text-white`}>
                    {agent.tag}
                  </span>
                </div>

                {/* Icon + Title */}
                <div className="flex items-start gap-4 mb-4">
                  <div className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-transform duration-300 ${agent.accentBg} ${isHovered ? "scale-110" : ""}`}>
                    <Icon className="w-7 h-7 text-white" strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0 pr-16">
                    <h3 className="font-serif text-lg text-spa-moss leading-tight mb-1" title={agent.name}>
                      {agent.name}
                    </h3>
                    <p className="text-sm text-spa-text-secondary leading-relaxed">
                      {agent.description}
                    </p>
                  </div>
                </div>

                {/* Conversation Starters */}
                <div className="mb-5 space-y-1.5">
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-spa-text-secondary/60 mb-2">Try asking</p>
                  {agent.starters.map((s, i) => (
                    <div key={`${agent.shortName}-starter-${i}`} className="flex items-start gap-2">
                      <span className={`w-1 h-1 rounded-full mt-1.5 flex-shrink-0 ${agent.accentBg}`}></span>
                      <p className="text-xs text-spa-text-secondary/80 leading-relaxed">{s}</p>
                    </div>
                  ))}
                </div>

                {/* Launch Button */}
                <a
                  href={agent.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                  data-testid={`launch-agent-${agent.id}`}
                >
                  <Button className={`w-full ${agent.accentBg} hover:opacity-90 text-white rounded-xl gap-2 transition-all`}>
                    Launch Agent <ExternalLink className="w-4 h-4" />
                  </Button>
                </a>
              </div>
            );
          })}

          {/* Locked agents for free users */}
          {!isFull && AGENTS.slice(2).map((agent) => (
            <Link
              key={agent.id}
              to="/pricing"
              className="spa-card relative overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100/50 border border-spa-border/30"
              data-testid={`locked-agent-${agent.id}`}
            >
              <div className="absolute inset-0 backdrop-blur-[2px] bg-white/50 z-10 flex flex-col items-center justify-center">
                <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center mb-3">
                  <Lock className="w-6 h-6 text-amber-600" />
                </div>
                <p className="font-serif text-lg text-spa-moss mb-1">{agent.shortName}</p>
                <p className="text-xs text-spa-text-secondary mb-3">{agent.tag} Agent</p>
                <span className="px-4 py-1.5 bg-spa-terracotta text-white rounded-full text-xs font-medium inline-flex items-center gap-1">
                  Unlock with Premium <ArrowRight className="w-3 h-3" />
                </span>
              </div>
              <div className="opacity-10 pointer-events-none p-6">
                <div className="w-14 h-14 bg-gray-300 rounded-2xl mb-4" />
                <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
                <div className="h-4 bg-gray-200 rounded w-1/2 mb-4" />
                <div className="h-20 bg-gray-200 rounded-xl" />
              </div>
            </Link>
          ))}
        </div>

        {/* Footer Note */}
        <div className="spa-card text-center bg-gradient-to-r from-spa-terracotta/5 to-spa-sage/5" data-testid="agents-footer">
          <p className="text-sm text-spa-text-secondary">
            All agents are powered by ChatGPT and created by <strong className="text-spa-moss">Mr. RAPsoul.R</strong> (M. Shirvington A. Hannays). 
            Each agent opens in a new tab on ChatGPT.com.
          </p>
          <p className="text-xs text-spa-text-secondary/60 mt-2">
            A ChatGPT account (free or paid) is required to interact with the agents.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
}
